import { h } from "./../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
import ReactDOM from 'react-dom';
import { emptyFn } from '../../utils/helper';
import Button from '../Button/index';
import { decideKeepDom } from '../../utils/keepDom';
import { consumeTheme } from '../../utils/theme';
import { PreventScrollPenetrateContainer } from '../../utils/preventScrollPenetrate';
import { WithStylusClick } from '../../utils/stylusAdapter';
import { i18n } from '../../common/locale';
export var MODAL_TRANSITION_DURATION = 200;
var Modal = (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleCancel = function (e) {
            _this.props.onCancel(e);
        };
        _this.handleOk = function (e) {
            var _a = _this.props, okDisabled = _a.okDisabled, onOk = _a.onOk;
            if (okDisabled) {
                return;
            }
            onOk(e);
        };
        _this.handleClose = function (e) {
            var _a = _this.props, onClose = _a.onClose, onCancel = _a.onCancel;
            var handler = onClose || onCancel;
            handler(e);
        };
        _this.handleMaskClick = function (e) {
            var _a = _this.props, maskClosable = _a.maskClosable, onClickMask = _a.onClickMask;
            if (maskClosable === true) {
                _this.handleClose(e);
            }
            onClickMask(e);
        };
        _this.handleModalClick = function (e) {
            e.stopPropagation();
        };
        _this.themedRender = function (classNames) {
            var _a, _b;
            var _c = _this.props, prefixCls = _c.prefixCls, className = _c.className, style = _c.style, title = _c.title, content = _c.content, visible = _c.visible, closable = _c.closable, mask = _c.mask, children = _c.children, destroyOnClose = _c.destroyOnClose, maskStyle = _c.maskStyle, zIndex = _c.zIndex, titleAlignment = _c.titleAlignment, testId = _c.testId, containerDom = _c.containerDom, disablePreventScroll = _c.disablePreventScroll;
            var classes = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-hidden"] = !visible,
                _a[prefixCls + "-no-mask"] = !mask,
                _a));
            var maskClasses = classNames(prefixCls + "-mask", (_b = {},
                _b[prefixCls + "-mask-display"] = mask,
                _b[prefixCls + "-mask-hidden"] = !visible,
                _b));
            var titleClasses = classNames(prefixCls + "-title", prefixCls + "-title-" + titleAlignment);
            if (destroyOnClose && !decideKeepDom.call(_this, MODAL_TRANSITION_DURATION, visible)) {
                return null;
            }
            return ReactDOM.createPortal(h(PreventScrollPenetrateContainer, { className: maskClasses, style: __assign({ zIndex: zIndex }, maskStyle), onClick: _this.handleMaskClick, disabled: disablePreventScroll },
                h("div", { className: classes, style: __assign({ overflow: 'initial' }, style), onClick: _this.handleModalClick, "data-testid": testId },
                    title ?
                        h("div", { className: titleClasses }, title)
                        : null,
                    h("div", { className: classNames(prefixCls + "-content") }, content || children),
                    _this.renderFooter(classNames),
                    closable ?
                        h(WithStylusClick, { clickHandler: _this.handleClose },
                            h("div", { className: classNames(prefixCls + "-close") }))
                        : null)), containerDom || document.body);
        };
        return _this;
    }
    Modal.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    Modal.prototype.renderFooter = function (classNames) {
        var _a = this.props, prefixCls = _a.prefixCls, footer = _a.footer, okText = _a.okText, cancelText = _a.cancelText, actions = _a.actions, okStyle = _a.okStyle, cancelStyle = _a.cancelStyle, footerType = _a.footerType, okButtonType = _a.okButtonType, okDisabled = _a.okDisabled;
        if (footer === null) {
            return null;
        }
        if (footer) {
            return footer;
        }
        if (actions) {
            return (h("div", { className: classNames(prefixCls + "-actions") }, actions.map(function (a, index) {
                return h(WithStylusClick, { clickHandler: a.onClick, key: index },
                    h(Button, null, a.text));
            })));
        }
        var isVerticalFooter = footerType === 'vertical';
        var buttonSize = isVerticalFooter ? 'large' : 'default';
        var okButton = (h(WithStylusClick, { clickHandler: this.handleOk },
            h(Button, { type: okButtonType || (isVerticalFooter ? 'primary' : 'default'), style: okStyle, size: buttonSize, disabled: okDisabled }, okText)));
        var cancelButton = cancelText ?
            h(WithStylusClick, { clickHandler: this.handleCancel },
                h(Button, { type: isVerticalFooter ? 'plain' : 'default', style: cancelStyle, size: buttonSize }, cancelText))
            : null;
        return (h("div", { className: classNames(isVerticalFooter ? prefixCls + "-footer-vertical" : prefixCls + "-footer") },
            cancelButton,
            okButton));
    };
    return Modal;
}(React.Component));
export default Modal;
Modal.defaultProps = {
    prefixCls: 'dui-m-modal',
    title: '',
    content: '',
    footer: '',
    onCancel: emptyFn,
    onOk: emptyFn,
    cancelText: i18n('cancel'),
    okText: i18n('ok'),
    visible: false,
    mask: true,
    destroyOnClose: false,
    onClickMask: emptyFn,
    maskClosable: false,
    titleAlignment: 'center',
    footerType: 'horizontal',
    closable: false,
};
